import React from 'react';
import IconDelete from 'images/trash3.png'

const DragHandle = ({ no, onTouchStart, onTouchMove, onTouchEnd }) => (
  <span
    className='url-drag-handle'
    title='ドラッグして並べ替え'
    onTouchStart={onTouchStart}
    onTouchMove={onTouchMove}
    onTouchEnd={onTouchEnd}
    style={{ display:'inline-flex', alignItems:'center', gap:'10px', cursor:'grab', userSelect:'none', color:'#9aa0a6', padding:'2px 4px', touchAction:'none' }}
  >
    <span style={{ fontWeight:700, fontSize:'14px', color:'#5f6368', minWidth:'14px', textAlign:'center' }}>{no}</span>
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 1.5 L2.5 5 M6 1.5 L9.5 5 M6 1.5 V8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 16.5 L2.5 13 M6 16.5 L9.5 13 M6 16.5 V10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </span>
);

const rowIndexFromPoint = (x, y) => {
  const el = document.elementFromPoint(x, y);
  if (!el) return null;
  const row = el.closest('tr[data-file-row]');
  if (!row) return null;
  const idx = row.getAttribute('data-file-row');
  return idx === null ? null : Number(idx);
};

const FileTable = ({ files, handleDeleteFile, handleUploadFiles, isDisableUpload, onCancel, dragIndex, setDragIndex, handleReorderFile }) => {
  const onTouchStart = (index) => () => { setDragIndex && setDragIndex(index); };
  const onTouchMove = (e) => { if (dragIndex === null) return; if (e.touches[0]) e.preventDefault(); };
  const onTouchEnd = (e) => {
    if (dragIndex === null) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (t) {
      const to = rowIndexFromPoint(t.clientX, t.clientY);
      if (to !== null && handleReorderFile) handleReorderFile(to);
      else setDragIndex && setDragIndex(null);
    } else { setDragIndex && setDragIndex(null); }
  };

  return (
  <div className=''>
    <div className='d-flex text-center justify-content-center align-items-center mt-2 mx-3'>
      <div className='w-80'>
        <div className='text-center mb-2 text-title-of-table'>
          { files.length === 0 ? 'アップロード対象データ' : `アップロード対象データ（${files.length}件｜${Shared.formatFileSize(files.reduce((sum, f) => sum + (f?.size || 0), 0), 1)}の読み込み完了済み）` }
        </div>
        <div className='show-table-files' style={{borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.2)',overflow:'visible'}}>
          <table className='w-100 table mb-1' style={{border:'none'}}>
            <thead className='bg-black w-100 text-white'>
              <tr>
                <th width="22%" style={{whiteSpace:'nowrap', padding:'4px', borderRight:'1px solid #dee2e6'}}>並び替え</th>
                <th width="14%" style={{whiteSpace:'nowrap', padding:'4px', borderRight:'1px solid #dee2e6'}}>削除</th>
                <th className='text-center' style={{borderRight:'1px solid #dee2e6'}}>ファイル名</th>
                <th width="14%" style={{whiteSpace:'nowrap', padding:'4px'}}>容量</th>
              </tr>
            </thead>
            <tbody className=''>
              {files.map((item, index) => (
                <tr key={index} data-file-row={index}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => { e.preventDefault(); handleReorderFile && handleReorderFile(index); }}
                    style={{ borderBottom: '1px solid #dee2e6', ...(dragIndex === index ? { opacity: 0.4 } : {}) }}>
                  <td
                    draggable={true}
                    onDragStart={() => setDragIndex && setDragIndex(index)}
                    onDragEnd={() => setDragIndex && setDragIndex(null)}
                    style={{padding:'4px', border:'none', borderRight:'1px solid #dee2e6', textAlign:'center', verticalAlign:'middle'}}>
                    <DragHandle
                      no={index + 1}
                      onTouchStart={onTouchStart(index)}
                      onTouchMove={onTouchMove}
                      onTouchEnd={onTouchEnd}
                    />
                  </td>
                  <td style={{padding: '4px', border:'none', borderRight:'1px solid #dee2e6', textAlign:'center', verticalAlign:'middle'}}>
                    <img className='filter-black-icon cursor-pointer' width={15} src={IconDelete}
                         onClick={() => handleDeleteFile(item, index)} />
                  </td>
                  <td className='text-left' style={{padding: '2px', border:'none', borderRight:'1px solid #dee2e6', verticalAlign:'middle'}}>{item?.name || ''}</td>
                  <td style={{padding: '2px', border:'none', textAlign:'center', verticalAlign:'middle'}}>
                    {item?.size ? Shared.formatFileSize(item?.size, 1) : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='text-left small-text-input-file w-100'>※番号の小さい順にアップロードされます。</div>
      </div>
    </div>
    <div className='text-center create-akaire-box-content my-3'>
      <button type='button' className='btn' style={{backgroundColor:'#000',color:'#fff',borderRadius:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.35)'}} disabled={isDisableUpload} onClick={(e) => handleUploadFiles(e) }>Uploadする</button>
      <button type='button' className='btn btn-secondary ml-2' style={{borderRadius:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.35)'}} onClick={() => onCancel && onCancel()}>キャンセル</button>
    </div>
  </div>
  );
};
export default FileTable;
